import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Lock, Clock } from "lucide-react";

const money = (v, cur = "GBP") =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: (cur || "GBP").toUpperCase(), maximumFractionDigits: 0 }).format(v || 0);

export default function QuoteLocksPanel() {
  const [locks, setLocks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/log/quote-locks");
        setLocks(data.locks || []);
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading) return null;
  if (!locks.length) return null;

  return (
    <div className="mv-card p-6" data-testid="locks-panel">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-2xl flex items-center justify-center mv-green-text" style={{ background: "rgba(212,175,55,0.16)" }}>
          <Lock size={18}/>
        </div>
        <div>
          <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>90-Day Price Locks</span></div>
          <div className="font-display text-lg mv-green-text">Your active price locks</div>
        </div>
      </div>
      <ul className="mt-4 divide-y mv-hairline">
        {locks.map((l) => {
          const expires = new Date(l.expires_at);
          const days = Math.max(0, Math.round((expires - Date.now()) / (24*3600*1000)));
          return (
            <li key={l.id} className="py-3 flex flex-wrap gap-3 justify-between items-center text-[14px]">
              <div>
                <div className="font-semibold mv-green-text">{money(l.property_price, l.currency)} · {l.term_years}yr</div>
                <div className="text-[12.5px]" style={{ color: "var(--mv-muted)" }}>
                  {l.lock_ref} · Monthly ≈ {money(l.monthly_payment, l.currency)}
                </div>
              </div>
              <div className="flex items-center gap-1 text-[12.5px]" style={{ color: days > 15 ? "var(--mv-muted)" : "#B33A3A" }}>
                <Clock size={13}/> {days} day{days === 1 ? "" : "s"} left
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
